export const de = {
    common: {
        appName: 'WooConnect',
        loading: 'Laden...',
        save: 'Speichern',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        create: 'Erstellen',
        search: 'Suchen',
        filter: 'Filter',
        refresh: 'Aktualisieren',
        retry: 'Erneut versuchen',
        confirm: 'Bestätigen',
        back: 'Zurück',
        next: 'Weiter',
        yes: 'Ja',
        no: 'Nein',
        all: 'Alle',
        none: 'Keine',
        noResults: 'Keine Ergebnisse gefunden',
        error: 'Etwas ist schiefgelaufen',
        success: 'Erfolg',
        required: 'Erforderlich',
        optional: 'Optional',
        comingSoon: 'Kommt bald',
        comingSoonDescription: 'Kommt im nächsten Update',
        actions: 'Aktionen',
        view: 'Anzeigen',
        close: 'Schließen',
        done: 'Fertig',
        add: 'Hinzufügen',
        update: 'Aktualisieren',
        enable: 'Aktivieren',
        disable: 'Deaktivieren',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        suspended: 'Gesperrt',
        showing: 'Zeige',
        of: 'von',
        perPage: 'pro Seite',
        viewAll: 'Alle anzeigen',
        notFound: 'Seite nicht gefunden',
        backToDashboard: 'Zurück zum Dashboard',
        selected: 'ausgewählt',
        noData: 'Keine Daten verfügbar',
        description: 'Beschreibung',
        type: 'Typ',
        date: 'Datum',
        amount: 'Betrag',
        reason: 'Grund',
        details: 'Details',
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        address: 'Adresse',
        company: 'Firma',
        status: 'Status',
        role: 'Rolle',
        version: 'Version',
        features: 'Funktionen',
        slug: 'Slug',
        price: 'Preis',
        created: 'Erstellt',
        from: 'Von',
        to: 'Bis',
        expires: 'Ablaufdatum',
        confirmDelete: 'Sind Sie sicher, dass Sie dies löschen möchten?',
        lastLogin: 'Letzte Anmeldung',
        remove: 'Entfernen',
        assign: 'Zuweisen',
        connect: 'Verbinden',
        disconnect: 'Trennen',
        test: 'Testen',
    },
    auth: {
        login: 'Anmelden',
        logout: 'Abmelden',
        email: 'E-Mail',
        password: 'Passwort',
        forgotPassword: 'Passwort vergessen?',
        resetPassword: 'Passwort zurücksetzen',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Passwort bestätigen',
        currentPassword: 'Aktuelles Passwort',
        changePassword: 'Passwort ändern',
        invalidCredentials: 'Ungültige E-Mail oder Passwort',
        invalidEmail: 'Ungültiges E-Mail-Format',
        minPassword: 'Mindestens 8 Zeichen',
        sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    },
    nav: {
        dashboard: 'Dashboard',
        orders: 'Bestellungen',
        products: 'Produkte',
        customers: 'Kunden',
        analytics: 'Analysen',
        notifications: 'Benachrichtigungen',
        settings: 'Einstellungen',
        users: 'Benutzer',
        subscriptions: 'Abonnements',
        plugins: 'Plugins',
        ai: 'KI',
        auditLog: 'Protokoll',
        systemSettings: 'Systemeinstellungen',
        apiDocs: 'API Dokumentation',
        marketing: 'Marketing',
        roleDefaults: 'Rollenvorgaben',
    },
    dashboard: {
        title: 'Dashboard',
        ordersToday: 'Bestellungen heute',
        revenueToday: 'Umsatz heute',
        revenueWeek: 'Wochenumsatz',
        revenueMonth: 'Monatsumsatz',
        totalProducts: 'Produkte gesamt',
        totalCustomers: 'Kunden gesamt',
        recentOrders: 'Letzte Bestellungen',
        selectStore: 'Shop wählen',
        pending: 'Ausstehend',
        processing: 'In Bearbeitung',
        thisWeek: 'Diese Woche',
        revenueChart: 'Umsatz',
        lowStockAlert: 'Bestandswarnungen',
        lowStockDesc: '{{low}} niedriger Bestand, {{out}} ausverkauft',
        loadTimeout: 'Daten konnten nicht geladen werden. Verbindung prüfen.',
    },
    orders: {
        title: 'Bestellungen',
        order: 'Bestellung',
        status: 'Status',
        customer: 'Kunde',
        total: 'Gesamt',
        date: 'Datum',
        items: 'Artikel',
        notes: 'Notizen',
        addNote: 'Notiz hinzufügen',
        addNotePlaceholder: 'Notiz schreiben...',
        changeStatus: 'Status ändern',
        refund: 'Rückerstattung',
        refundAmount: 'Erstattungsbetrag',
        refundReason: 'Erstattungsgrund',
        bulkUpdate: 'Massenaktualisierung',
        noOrders: 'Keine Bestellungen',
        noNotes: 'Keine Notizen',
        showSystemNotes: 'Technische Notizen anzeigen',
        hideSystemNotes: 'Technische Notizen ausblenden',
        subtotal: 'Zwischensumme',
        shipping: 'Versand',
        tax: 'Steuer',
        discount: 'Rabatt',
        payment: 'Zahlung',
        billing: 'Rechnungsstellung',
        billingAddress: 'Rechnungsadresse',
        shippingAddress: 'Lieferadresse',
        sendToCustomer: 'An Kunden senden',
        customerNote: 'Kundennotiz',
        transactionId: 'Transaktions-ID',
        fees: 'Gebühren',
        refundsTitle: 'Rückerstattungen',
        dateCompleted: 'Abgeschlossen',
        each: 'pro Stück',
        datePaid: 'Bezahlt am',
        confirmStatusChange: 'Bestellung {{orderNumber}} auf "{{status}}" ändern?',
        bulkConfirmStatusChange: '{{count}} Bestellungen auf "{{status}}" ändern?',
        coupon: 'Gutschein',
        statuses: {
            pending: 'Ausstehend',
            processing: 'In Bearbeitung',
            'on-hold': 'Wartend',
            completed: 'Abgeschlossen',
            cancelled: 'Storniert',
            refunded: 'Erstattet',
            failed: 'Fehlgeschlagen',
        },
    },
    products: {
        title: 'Produkte',
        name: 'Name',
        price: 'Preis',
        regularPrice: 'Regulärer Preis',
        salePrice: 'Angebotspreis',
        stock: 'Bestand',
        stockQuantity: 'Bestandsmenge',
        manageStock: 'Bestand verwalten',
        lowStockThreshold: 'Niedrigbestandsgrenze',
        category: 'Kategorie',
        categories: 'Kategorien',
        tags: 'Tags',
        status: 'Status',
        lowStock: 'Niedriger Bestand',
        outOfStock: 'Ausverkauft',
        inStock: 'Auf Lager',
        noProducts: 'Keine Produkte',
        sku: 'SKU',
        published: 'Veröffentlicht',
        draft: 'Entwurf',
        simple: 'Einfach',
        variable: 'Variabel',
        quickEdit: 'Schnellbearbeitung',
        salePriceMustBeLower: 'Der Angebotspreis muss niedriger als der reguläre Preis sein',
        stockCannotBeNegative: 'Die Bestandsmenge darf nicht negativ sein',
        leaveEmptyToRemoveSale: 'Leer lassen um Angebot zu entfernen',
        images: 'Bilder',
        description: 'Beschreibung',
        productInfo: 'Produktinfo',
        pricing: 'Preise',
        inventory: 'Inventar',
        stockStatus: 'Bestandsstatus',
        productType: 'Produkttyp',
        totalSales: 'Gesamtverkäufe',
    },
    customers: {
        title: 'Kunden',
        name: 'Name',
        email: 'E-Mail',
        totalSpent: 'Gesamtausgaben',
        ordersCount: 'Bestellungen',
        lastOrder: 'Letzte Bestellung',
        noCustomers: 'Keine Kunden',
        segment: 'Segment',
        customerSince: 'Kunde seit',
        averageOrder: 'Durchschnittlicher Bestellwert',
        recentOrders: 'Letzte Bestellungen',
        profile: 'Profil',
        billingAddress: 'Rechnungsadresse',
        shippingAddress: 'Lieferadresse',
        stats: 'Statistiken',
        syncNote: 'Kundenstatistiken (Bestellungen, Ausgaben) müssen möglicherweise in WooCommerce Analytics synchronisiert werden.',
        segments: {
            vip: 'VIP',
            repeat: 'Stammkunde',
            new: 'Neu',
            inactive: 'Inaktiv',
        },
    },
    analytics: {
        attribution: 'Attribution',
        attributionRate: 'Attributionsrate',
        topSource: 'Top-Quelle',
        topCampaign: 'Top-Kampagne',
        mobileShare: 'Mobil-Anteil',
        sourceConversion: 'Quelle → Conversion',
        source: 'Quelle',
        campaigns: 'Kampagnen',
        devices: 'Geräte',
        attributionUnavailable: 'Attribution nicht verfügbar',
        attributionNeedsBridge: 'Attribution erfordert das WooConnect Bridge-Plugin in diesem Shop.',
        attributionCoverageNote: 'Nur {{pct}}% der Bestellungen haben Attributionsdaten; der Rest als Direct/Untracked.',
        title: 'Analysen',
        revenueThisMonth: 'Umsatz diesen Monat',
        ordersThisMonth: 'Bestellungen diesen Monat',
        averageOrderValue: 'Durchschnittlicher Bestellwert',
        newCustomers: 'Neue Kunden',
        revenue: 'Umsatz',
        topSellers: 'Topseller',
        sales: 'Verkäufe',
        statusBreakdown: 'Statusverteilung',
        customerAnalytics: 'Kundenanalyse',
        period: 'Zeitraum',
        daily: 'Täglich',
        weekly: 'Wöchentlich',
        monthly: 'Monatlich',
        days7: '7 Tage',
        days14: '14 Tage',
        days30: '30 Tage',
        days90: '90 Tage',
        advancedAnalytics: 'Erweiterte Analysen',
        advancedDescription: 'Erweiterte Kundeneinblicke, Umsatztrends und mehr.',
        learnMore: 'Mehr erfahren',
        viewAnalytics: 'Analysen',
        sold: 'verkauft',
        noTopSellers: 'Keine Topseller-Daten',
        trend: 'Trend',
        days365: '1 Jahr',
        revenueComparison: 'Umsatzvergleich',
        currentPeriod: 'Aktuelle Periode',
        previousPeriod: 'Vorherige Periode',
        metric: 'Kennzahl',
        change: 'Veränderung',
        paymentMethods: 'Zahlungsmethoden',
        noPaymentData: 'Keine Zahlungsdaten verfügbar',
        orders: 'Bestellungen',
        customerStats: 'Kundenübersicht',
        totalCustomers: 'Kunden gesamt',
        newThisMonth: 'Neu diesen Monat',
        newLastMonth: 'Neu letzten Monat',
        topCustomersBySpend: 'Top-Kunden nach Ausgaben',
        noCustomerData: 'Keine Kundendaten verfügbar',
        lowStockAlerts: 'Bestandswarnungen',
        lowStockItems: '{{count}} Artikel mit niedrigem Bestand',
        outOfStockItems: '{{count}} Artikel ausverkauft',
        viewProducts: 'Produkte anzeigen',
        image: 'Bild',
        product: 'Produkt',
        totalOrders: 'Bestellungen gesamt',
        vsLastMonth: 'ggb. letztem Monat',
        // Tab labels
        overview: 'Übersicht',
        products: 'Produkte',
        customers: 'Kunden',
        stock: 'Lagerbestand',
        coupons: 'Gutscheine',
        taxes: 'Steuern',
        // Date range
        dateRange: 'Zeitraum',
        compareTo: 'Vergleichen mit',
        previousYear: 'Vorjahr',
        today: 'Heute',
        yesterday: 'Gestern',
        last7days: 'Letzte 7 Tage',
        last30days: 'Letzte 30 Tage',
        thisMonth: 'Dieser Monat',
        lastMonth: 'Letzter Monat',
        thisQuarter: 'Dieses Quartal',
        thisYear: 'Dieses Jahr',
        customRange: 'Benutzerdefinierter Zeitraum',
        // Revenue metrics
        grossSales: 'Bruttoumsatz',
        netRevenue: 'Nettoumsatz',
        ordersCount: 'Bestellungen',
        productsSold: 'Verkaufte Produkte',
        insightBestDay: 'Bester Tag',
        insightConcentration: 'Top 3 Produkte bringen',
        insightAov: 'Ø Bestellwert',
        unitsShort: 'Stk.',
        netExclVat: 'Nettoumsatz · ohne MwSt.',
        alertAovDrop: 'Durchschnittlicher Bestellwert {{value}}% niedriger als in der Vorperiode',
        alertRevenueDrop: 'Nettoumsatz {{value}}% niedriger als in der Vorperiode',
        alertHighRefunds: 'Rückerstattungsrate betragt {{value}}%',
        alertLowAttribution: 'Nur {{value}}% der Bestellungen haben Attributionsdaten',
        itemsSold: 'Verkaufte Artikel',
        avgOrderValue: 'Durchschn. Bestellwert',
        avgItemsPerOrder: 'Durchschn. Artikel/Bestellung',
        couponsUsed: 'Gutscheine eingelöst',
        couponsAmount: 'Gutscheinbetrag',
        shippingTotal: 'Versand',
        taxesTotal: 'Steuern',
        refundsTotal: 'Rückerstattungen',
        vsLastPeriod: 'ggb. vorheriger Periode',
        // Order Intelligence / Profit (Wave 2)
        profitMargin: 'Gewinn & Marge',
        grossProfit: 'Bruttogewinn',
        margin: 'Marge',
        cogs: 'Wareneinsatz',
        costCoverage: 'Kostendeckung',
        costCoverageHint: 'des Umsatzes haben Kostendaten',
        noCostData: 'Keine Produktkostendaten',
        noCostDataHint: 'Füge deinen Produkten Wareneinsatzkosten hinzu, um Gewinn und Marge zu sehen.',
        refunds: 'Rückerstattungen',
        refundRate: 'Rückerstattungsquote',
        refundsCount: 'Rückerstattungen',
        avgRefund: 'Ø Rückerstattung',
        avg: 'Ø',
        orderValueDistribution: 'Bestellwert-Verteilung',
        topCustomersHint: 'Lebenslange Ausgaben · in diesem Zeitraum aktive Kunden',
        // Customer Intelligence (Wave 3)
        customerIntel: 'Kundenanalyse',
        returningCustomers: 'Wiederkehrend',
        repeatRate: 'Wiederkaufrate',
        avgLifetimeValue: 'Ø Lifetime-Wert',
        ordersPerCustomer: 'Bestellungen/Kunde',
        topCustomersPeriod: 'Top-Kunden (Zeitraum)',
        periodSpend: 'Ausgaben (Zeitraum)',
        rfmSegments: 'Kundensegmente (RFM)',
        topCities: 'Top-Städte',
        stockValue: 'Lagerwert',
        discountOfGross: '% vom Brutto',
        browsers: 'Browser',
        customersBySource: 'Kunden nach Quelle',
        landingPages: 'Landingpages',
        cohorts: 'Kohorten-Bindung',
        cohortsHint: '% jedes Akquisemonats mit Wiederbestellung',
        stockVelocity: 'Bald ausverkauft',
        daysLeft: 'Tage',
        inStockShort: 'auf Lager',
        alerts: 'Warnungen',
        platinum: 'Platin',
        gold: 'Gold',
        silver: 'Silber',
        bronze: 'Bronze',
        avgDaysBetween: 'Ø Tage zwischen Bestellungen',
        avgRecency: 'Ø Aktualität',
        lifetimeShort: 'gesamt',
        // Product Intelligence (Wave 4)
        topVariations: 'Top-Varianten',
        frequentlyBoughtTogether: 'Häufig zusammen gekauft',
        // Sales Patterns (Wave 5)
        salesByDay: 'Verkäufe nach Tag',
        peakHours: 'Stoßzeiten',
        shippingMethods: 'Versandarten',
        byCountry: 'Nach Land',
        // Abandoned Cart Recovery (Wave 6)
        abandonedCarts: 'Warenkorbabbruch-Recovery',
        cartsCaptured: 'Erfasste Warenkörbe',
        recovered: 'wiederhergestellt',
        recoveredValue: 'Wiederhergestellter Wert',
        lostValue: 'Verlorener Wert',
        // Compare (Wave 7)
        compareTitle: 'Periodenvergleich',
        current: 'Aktuell',
        // Products tab
        topProducts: 'Top-Produkte',
        productName: 'Produkt',
        unitsSold: 'Verkaufte Einheiten',
        categoryBreakdown: 'Kategorieverteilung',
        category: 'Kategorie',
        productsCount: 'Produkte',
        revenueByCategory: 'Umsatz nach Kategorie',
        noProductData: 'Keine Produktdaten für diesen Zeitraum',
        // Orders tab
        orderStatus: 'Bestellstatus',
        netSales: 'Nettoumsatz',
        avgItems: 'Durchschn. Artikel',
        ordersByDay: 'Bestellungen im Zeitverlauf',
        statusBreakdownTitle: 'Statusverteilung',
        paymentMethodsTitle: 'Zahlungsmethoden',
        // Customers tab
        totalCustomersCount: 'Kunden gesamt',
        avgOrders: 'Durchschn. Bestellungen',
        avgSpend: 'Durchschn. Ausgaben',
        topCustomersTitle: 'Top-Kunden',
        totalSpent: 'Gesamtausgaben',
        lastActive: 'Zuletzt aktiv',
        customersByLocation: 'Kunden nach Standort',
        noCustomers: 'Keine Kundendaten für diesen Zeitraum',
        // Stock tab
        stockSummary: 'Bestandsübersicht',
        inStock: 'Auf Lager',
        lowStockLabel: 'Niedriger Bestand',
        outOfStockLabel: 'Ausverkauft',
        onBackorder: 'In Nachbestellung',
        lowStockProducts: 'Produkte mit niedrigem Bestand',
        stockStatus: 'Status',
        quantity: 'Menge',
        noStockData: 'Keine Bestandsdaten verfügbar',
        // Coupons tab
        topCoupons: 'Top-Gutscheine',
        couponCode: 'Gutscheincode',
        discount: 'Rabatt',
        couponsOverTime: 'Gutscheine im Zeitverlauf',
        totalDiscount: 'Gesamtrabatt',
        ordersWithCoupons: 'Bestellungen mit Gutscheinen',
        noCouponData: 'Keine Gutscheindaten für diesen Zeitraum',
        // Taxes tab
        taxRates: 'Steuersätze',
        taxRate: 'Steuersatz',
        orderTax: 'Bestellsteuer',
        shippingTax: 'Versandsteuer',
        totalTax: 'Gesamtsteuer',
        noTaxData: 'Keine Steuerdaten für diesen Zeitraum',
        // Compare
        compare: 'Vergleichen',
        difference: 'Differenz',
        thisPeriod: 'Dieser Zeitraum',
        fullAnalyticsInPanel: 'Vollständige Analysen im Panel',
        // VAT
        inclVat: '(inkl. MwSt.)',
        exclVat: '(exkl. MwSt.)',
        // Status filter
        statusFilter: 'Bestellstatus',
        allStatuses: 'Alle Status',
        // Settings tab
        settings: 'Einstellungen',
        settingsTitle: 'Analyse-Einstellungen',
        dateDisplay: 'Datum & Anzeige',
        defaultPreset: 'Standard-Zeitraum',
        dateColumnLabel: 'Datumsspalte',
        dateCreated: 'Bestellung erstellt',
        datePaid: 'Bestellung bezahlt',
        dateCompleted: 'Bestellung abgeschlossen',
        weekStartsOn: 'Woche beginnt am',
        monday: 'Montag',
        sunday: 'Sonntag',
        // Order status settings
        orderStatusesTitle: 'Bestellstatus',
        paidStatusesHelp: 'Welche Status als BEZAHLT für Umsatz und Verkäufe zählen. Standardmäßig sind nur „In Bearbeitung" und „Abgeschlossen" ausgewählt.',
        syncedFromWc: 'Synchronisiert von WooCommerce: {{count}} Status ({{custom}} benutzerdefiniert)',
        syncFromStore: 'Vom Shop synchronisieren',
        syncing: 'Synchronisiere...',
        syncSuccess: 'Einstellungen vom Shop synchronisiert',
        customStatus: 'Benutzerdefiniert',
        defaultStatus: 'Standard',
        paid: 'Bezahlt',
        unpaid: 'Unbezahlt',
        // Store info
        storeInfo: 'Shop-Info',
        taxesEnabledLabel: 'Steuern',
        hposEnabledLabel: 'HPOS',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        lastSynced: 'Zuletzt synchronisiert',
        never: 'Nie',
        settingsSaved: 'Analyse-Einstellungen gespeichert',
        // New presets
        last14days: 'Letzte 14 Tage',
        last90days: 'Letzte 90 Tage',
        last365days: 'Letzte 365 Tage',
        thisWeek: 'Diese Woche',
        lastWeek: 'Letzte Woche',
        // Compare tab
        compareDefaultPreset: 'Standard-Vergleich',
        periodA: 'Zeitraum A',
        periodB: 'Zeitraum B',
        customDates: 'Benutzerdefiniert',
        customFrom: 'Von',
        customTo: 'Bis',
        selectDate: 'Datum wählen',
        // Tab extras
        noOrderData: 'Keine Bestelldaten für diesen Zeitraum',
        compareMode: 'Vergleich',
        filterByStatus: 'Nach Status filtern',
        location: 'Standort',
        stockProducts: 'Produkte',
        rate: 'Satz',
        // General
        noData: 'Keine Daten für diesen Zeitraum',
        loading: 'Analysen werden geladen...',
        couponsTotal: 'Gutscheine Gesamt',
        timezone: 'Zeitzone',
    },
    notifications: {
        title: 'Benachrichtigungen',
        markRead: 'Als gelesen markieren',
        markAllRead: 'Alle als gelesen markieren',
        noNotifications: 'Keine Benachrichtigungen',
        preferences: 'Benachrichtigungseinstellungen',
        unread: 'Ungelesen',
        orderNotifications: 'Bestellungen',
        stockNotifications: 'Bestand',
        systemNotifications: 'System',
        newOrder: 'Neue Bestellung',
        viewAll: 'Alle anzeigen',
        statusChanges: 'Statusänderungen',
        lowStock: 'Niedriger Bestand',
        lowStockAlerts: 'Niedriger Bestand',
        refundAlerts: 'Rückerstattungen',
        backorderAlerts: 'Nachbestellungen',
        dailySummary: 'Tägliche Zusammenfassung',
        prefsSaved: 'Benachrichtigungseinstellungen gespeichert',
        prefsDescription: 'Wählen Sie welche Benachrichtigungen Sie für diesen Shop erhalten möchten.',
        orderStatusChanged: 'Bestellstatusänderungen',
        refundRequest: 'Rückerstattungsanfragen',
        productBackorder: 'Produkt-Nachbestellungen',
        deleteAll: 'Alle löschen',
        confirmDeleteAll: 'Alle Benachrichtigungen löschen?',
        allDeleted: 'Alle Benachrichtigungen gelöscht',
        allStores: 'Alle Shops',
        tpl: {
            newOrderTitle: 'Neue Bestellung #{{number}}',
            newOrderBody: '{{name}} hat eine Bestellung über {{currency}} {{total}} aufgegeben',
            statusChangedTitle: 'Bestellung #{{number}} Aktualisiert',
            statusChangedBody: 'Status von {{oldStatus}} zu {{newStatus}} geändert',
            lowStockTitle: 'Niedriger Bestand: {{product}}',
            lowStockBody: 'Nur noch {{quantity}} Einheiten (SKU: {{sku}})',
            refundTitle: 'Rückerstattung Bestellung #{{orderId}}',
            refundBody: '{{amount}} erstattet. Grund: {{reason}}',
            backorderTitle: 'Nachbestellung: {{product}}',
            backorderBody: '{{product}} ist in Nachbestellung (SKU: {{sku}})',
        },
    },
    settings: {
        title: 'Einstellungen',
        profile: 'Profil',
        stores: 'Verbundene Shops',
        appearance: 'Darstellung',
        language: 'Sprache',
        theme: 'Design',
        integrations: 'Integrationen',
        about: 'Info',
        notificationPrefs: 'Benachrichtigungen',
        themeLight: 'Hell',
        themeDark: 'Dunkel',
        themeSystem: 'System',
        dateFormat: 'Datumsformat',
        itemsPerPage: 'Eintr. pro Seite',
        emailReadOnly: 'Kontaktieren Sie den Admin um die E-Mail zu ändern',
        firstName: 'Vorname',
        lastName: 'Nachname',
        avatarUrl: 'Avatar-URL',
        storeUrl: 'Shop-URL',
        wcKey: 'WooCommerce-Schlüssel',
        wcSecret: 'WooCommerce-Geheimnis',
        bridgeKey: 'Bridge-Schlüssel',
        storeName: 'Shopname',
        account: 'Konto',
        session: 'Sitzung',
        security: 'Sicherheit',
        biometricLogin: 'Biometrische Anmeldung',
        editProfile: 'Profil bearbeiten',
        confirmLogout: 'Von WooConnect abmelden?',
        confirmLogoutMessage: 'Sie müssen sich erneut anmelden, um auf Ihre Shops zuzugreifen.',
        support: 'Support',
        preferences: 'Einstellungen',
        passwordMinLength: 'Passwort muss mindestens 8 Zeichen haben',
        passwordsMustMatch: 'Passwörter müssen übereinstimmen',
        passwordChanged: 'Passwort erfolgreich geändert',
        profileSaved: 'Profil gespeichert',
    },
    sites: {
        title: 'Shops',
        addStore: 'Shop verbinden',
        testConnection: 'Verbindung testen',
        disconnect: 'Trennen',
        health: 'Status',
        online: 'Online',
        offline: 'Offline',
        noSites: 'Keine Shops verbunden',
        editStore: 'Shop bearbeiten',
        confirmDisconnect: 'Dies wird den Zugang für alle Benutzer dieses Shops entfernen. Sind Sie sicher?',
        connectionSuccess: 'Shop erfolgreich verbunden',
        connectionFailed: 'Verbindung fehlgeschlagen',
        testSuccess: 'Verbindungstest bestanden',
        testFailed: 'Verbindungstest fehlgeschlagen',
        wcConnected: 'WooCommerce: Verbunden',
        wcFailed: 'WooCommerce: Fehlgeschlagen',
        bridgeConnected: 'Bridge: Verbunden',
        bridgeFailed: 'Bridge: Nicht verbunden',
        bridgeNotInstalled: 'Bridge: Nicht installiert',
        currency: 'Währung',
        timezone: 'Zeitzone',
        connectedSince: 'Verbunden seit',
        wcVersion: 'WC-Version',
        wpVersion: 'WP-Version',
        bridgeVersion: 'Bridge-Version',
        bridgeLabel: 'Bridge {{version}}',
        urlMustBeHttps: 'URL muss mit https:// beginnen',
        invalidWcKey: 'Muss mit ck_ beginnen',
        invalidWcSecret: 'Muss mit cs_ beginnen',
    },
    subscription: {
        title: 'Abonnement',
        plan: 'Plan',
        status: 'Status',
        expiresAt: 'Läuft ab',
        extend: 'Verlängern',
        changePlan: 'Plan ändern',
        maxSites: 'Max. Shops',
        priceAmount: 'Preis',
        plans: {
            free_trial: 'Kostenlose Testversion',
            monthly: 'Monatlich',
            yearly: 'Jährlich',
            lifetime: 'Lebenslang',
            custom: 'Benutzerdefiniert',
        },
        statuses: {
            trial: 'Testversion',
            active: 'Aktiv',
            expired: 'Abgelaufen',
            cancelled: 'Storniert',
            expiring_soon: 'Läuft bald ab',
            grace_period: 'Karenzzeit',
        },
    },
    plugins: {
        title: 'Plugins',
        installed: 'Installiert',
        notInstalled: 'Nicht installiert',
        required: 'Erforderlich',
        getPlugin: 'Plugin holen',
        notifyAdmin: 'Plugin anfragen',
        addPlugin: 'Plugin hinzufügen',
        noPlugins: 'Keine Plugins registriert',
        bridgeTitle: 'WooConnect Bridge Plugin',
        bridgeDescription: 'Erforderliches WordPress-Plugin, das Ihren WooCommerce-Shop mit der WooConnect-Plattform verbindet. Installieren Sie es in jedem Shop, den Sie verwalten möchten.',
        installGuide: 'Installationsanleitung',
        step1: 'Laden Sie die ZIP-Datei mit der Schaltfläche unten herunter',
        step2: 'Gehen Sie in WordPress zu Plugins > Neu hinzufügen > Plugin hochladen',
        step3: 'Laden Sie die ZIP-Datei hoch und klicken Sie auf Jetzt installieren',
        step4: 'Aktivieren Sie das Plugin und geben Sie den Bridge API Key aus den Shop-Einstellungen ein',
        downloadBridge: 'Plugin herunterladen',
        bridgeVersion: 'Version',
        bridgeRequirements: 'Anforderungen',
        bridgeRequiresWP: 'WordPress {{version}}+',
        bridgeRequiresPHP: 'PHP {{version}}+',
        bridgeRequiresWC: 'WooCommerce {{min}}+ (getestet bis {{max}})',
        bridgeWhatsNew: 'Neuigkeiten',
        copySteps: 'Schritte kopieren',
        copied: 'Kopiert',
        installSteps: '1. ZIP-Datei herunterladen\n2. In WordPress: Plugins > Neu hinzufügen > Plugin hochladen\n3. ZIP hochladen und Jetzt installieren klicken\n4. Aktivieren und Bridge API Key aus Shop-Einstellungen eingeben',
    },
    ai: {
        title: 'KI-Assistent',
        chat: 'Chat',
        composeEmail: 'E-Mail verfassen',
        businessProfile: 'Geschäftsprofil',
        usage: 'KI-Nutzung',
        totalCost: 'Gesamtkosten diesen Monat',
        requestsByFeature: 'Anfragen pro Funktion',
        costByUser: 'Kosten pro Benutzer',
        aiEnabled: 'KI aktiviert',
        defaultModel: 'Standardmodell',
        maxTokens: 'Max. Tokens',
        usageLimits: 'Nutzungslimits',
        requests: 'Anfragen',
        cost: 'Kosten',
        totalRequests: 'Anfragen gesamt',
        features: 'Funktionen',
    },
    admin: {
        title: 'Verwaltung',
        users: 'Benutzer',
        createUser: 'Benutzer erstellen',
        editUser: 'Benutzer bearbeiten',
        resetPassword: 'Passwort zurücksetzen',
        changeStatus: 'Status ändern',
        userDetail: 'Benutzerdetails',
        noUsers: 'Keine Benutzer gefunden',
        subscriptions: 'Abonnements',
        extendSubscription: 'Abonnement verlängern',
        days30: '+30 Tage',
        days90: '+90 Tage',
        year1: '+1 Jahr',
        custom: 'Benutzerdefiniert',
        noSubscriptions: 'Keine Abonnements gefunden',
        auditLog: 'Protokoll',
        noAuditLogs: 'Keine Protokolleinträge gefunden',
        action: 'Aktion',
        user: 'Benutzer',
        site: 'Shop',
        time: 'Zeit',
        ipAddress: 'IP-Adresse',
        settings: 'App-Einstellungen',
        settingKey: 'Schlüssel',
        settingValue: 'Wert',
        editSetting: 'Einstellung bearbeiten',
        expiringWithin: 'Ablauf innerhalb',
        days: 'Tagen',
        plugins: 'Plugins',
        addPlugin: 'Plugin hinzufügen',
        noPlugins: 'Keine Plugins registriert',
        appSettings: 'App-Einstellungen',
        section: 'Verwaltung',
        deleteUser: 'Benutzer löschen',
        confirmDeleteUser: 'Dies wird den Benutzer deaktivieren und alle Sitzungen widerrufen. Sind Sie sicher?',
        resetPasswordDesc: 'Neues Passwort für diesen Benutzer festlegen. Alle Sitzungen werden beendet.',
        assignStore: 'Shop zuweisen',
        unassignStore: 'Shop entfernen',
        confirmUnassignStore: 'Dies wird den Shop-Zugang für diesen Benutzer entfernen. Sind Sie sicher?',
        editPermissions: 'Berechtigungen bearbeiten',
        permissions: 'Berechtigungen',
        assignedStores: 'Zugewiesene Shops',
        noAssignedStores: 'Keine Shops für diesen Benutzer zugewiesen',
        allStoresAssigned: 'Alle Shops sind diesem Benutzer bereits zugewiesen',
        selectStore: 'Shop wählen',
        changePlan: 'Plan ändern',
        notes: 'Notizen',
        roleDefaults: 'Rollenvorgaben',
        roleDefaultsTitle: 'Standardberechtigungen nach Rolle',
        roleDefaultsDescription: 'Konfigurieren Sie, welche Berechtigungen jede Rolle standardmäßig bei der Zuweisung zu einem Shop erhält. Änderungen betreffen nur neue Zuweisungen -- bestehende Benutzerberechtigungen bleiben unverändert.',
        roleDefaultsSaved: 'Rollenvorgaben gespeichert',
        roleDefaultsReset: 'Auf Standard zurücksetzen',
        roleDefaultsResetConfirm: 'Alle Rollenvorgaben auf die eingebauten Werte zurücksetzen?',
        roleDefaultsNoChanges: 'Keine Änderungen zu speichern',
    },
    adminSettings: {
        aiEnabled: 'KI aktiviert',
        aiEnabledDesc: 'Globale KI-Funktionsumschaltung',
        aiModel: 'KI-Modell',
        aiModelDesc: 'Standard-Claude-Modell',
        aiMaxTokens: 'Max. KI-Tokens',
        aiMaxTokensDesc: 'Max. Tokens pro KI-Anfrage',
        maintenance: 'Wartungsmodus',
        maintenanceDesc: 'Wartungsmodus aktivieren',
        versionIos: 'iOS-Version',
        versionIosDesc: 'Aktuelle iOS-App-Version',
        versionPanel: 'Panel-Version',
        versionPanelDesc: 'Aktuelle Panel-Version',
        bridgeVersion: 'Min. Bridge-Version',
        bridgeVersionDesc: 'Mindestens erforderliche Bridge-Plugin-Version',
        cacheDashboard: 'Dashboard-Cache (Sek.)',
        cacheDashboardDesc: 'Dashboard-Cache-Zeit in Sekunden',
        cacheOrders: 'Bestellungen-Cache (Sek.)',
        cacheOrdersDesc: 'Bestellungen-Cache-Zeit in Sekunden',
        cacheProducts: 'Produkte-Cache (Sek.)',
        cacheProductsDesc: 'Produkte-Cache-Zeit in Sekunden',
        graceDays: 'Karenztage',
        graceDaysDesc: 'Tage nach Ablauf vor Deaktivierung',
        notifyDays: 'Benachrichtigungstage',
        notifyDaysDesc: 'Tage vor Ablauf für Benachrichtigung',
        apiDocsTitle: 'API Dokumentation',
        apiDocsDesc: 'Öffnet in neuem Tab',
    },
    auditLog: {
        auth: { login: 'Anmeldung', logout: 'Abmeldung', password_changed: 'Passwort geändert' },
        user: { created: 'Benutzer erstellt', updated: 'Benutzer aktualisiert', status_changed: 'Status geändert' },
        site: { connected: 'Shop verbunden', disconnected: 'Shop getrennt' },
        order: { status_changed: 'Bestellstatus geändert', note_added: 'Notiz hinzugefügt', refund_created: 'Rückerstattung erstellt' },
        product: { updated: 'Produkt aktualisiert' },
        settings: { updated: 'Einstellungen aktualisiert' },
        subscription: { updated: 'Abonnement aktualisiert', extended: 'Abonnement verlängert' },
        permission: { assigned: 'Berechtigung zugewiesen' },
    },
    roles: {
        super_admin: 'Superadmin',
        admin: 'Admin',
        user: 'Benutzer',
        store_owner: 'Shopinhaber',
        manager: 'Manager',
        staff: 'Mitarbeiter',
    },
    permissions: {
        ordersView: 'Bestellungen anzeigen',
        ordersEdit: 'Bestellungen bearbeiten',
        ordersRefund: 'Bestellungen erstatten',
        productsView: 'Produkte anzeigen',
        productsEdit: 'Produkte bearbeiten',
        customersView: 'Kunden anzeigen',
        analyticsView: 'Analysen anzeigen',
        analyticsAdvanced: 'Erweiterte Analysen',
        notificationsEnabled: 'Benachrichtigungen',
        settingsView: 'Einstellungen anzeigen',
        settingsEdit: 'Einstellungen bearbeiten',
        aiChat: 'KI-Chat',
    },
    marketing: {
        title: 'Marketing',
        test: 'Test',
        compose: 'Erstellen',
        templates: 'Vorlagen',
        history: 'Verlauf',
        queue: 'Warteschlange',
        testSend: 'Testversand',
        recipient: 'Empfänger',
        channels: 'Kanäle',
        push: 'Push-Benachrichtigung',
        email: 'E-Mail',
        panelNotification: 'Panel-Benachrichtigung',
        allChannels: 'Alle Kanäle',
        messageTitle: 'Titel',
        messageBody: 'Nachricht',
        deepLink: 'Deep Link',
        deepLinkNone: 'Keiner',
        deepLinkDashboard: 'Dashboard',
        deepLinkOrder: 'Bestellung',
        deepLinkUrl: 'Externe URL',
        sendTest: 'Testversand',
        testHistory: 'Testverlauf',
        result: 'Ergebnis',
        delivered: 'Zugestellt',
        sent: 'Gesendet',
        failed: 'Fehlgeschlagen',
        pending: 'Ausstehend',
        sending: 'Wird gesendet',
        cancelled: 'Abgebrochen',
        draft: 'Entwurf',
        newCampaign: 'Neue Kampagne',
        template: 'Vorlage',
        noTemplate: 'Keine Vorlage',
        recipients: 'Empfänger',
        allActiveUsers: 'Alle aktiven Benutzer',
        byRole: 'Nach Rolle',
        specificUsers: 'Bestimmte Benutzer',
        sendNow: 'Jetzt senden',
        scheduleFor: 'Planen für',
        scheduled: 'Geplant',
        preview: 'Vorschau',
        testToMe: 'Test an mich',
        sendOrSchedule: 'Senden / Planen',
        newTemplate: 'Neue Vorlage',
        templateName: 'Vorlagenname',
        templateCategory: 'Kategorie',
        variables: 'Variablen',
        systemTemplate: 'Systemvorlage',
        customTemplate: 'Benutzerdefiniert',
        welcome: 'Willkommen',
        reminder: 'Erinnerung',
        summary: 'Bericht',
        promo: 'Werbung',
        alert: 'Warnung',
        custom: 'Benutzerdefiniert',
        exportCsv: 'CSV exportieren',
        campaignDetail: 'Kampagnendetails',
        recipientResults: 'Ergebnisse pro Empfänger',
        scheduledMessages: 'Geplante Nachrichten',
        edit: 'Bearbeiten',
        cancel: 'Abbrechen',
        sendImmediately: 'Jetzt senden',
        confirmCancel: 'Geplante Nachricht abbrechen?',
        confirmSendNow: 'Diese Nachricht jetzt senden?',
        confirmDelete: 'Diese Vorlage löschen?',
        hasPushToken: 'Hat Push Token',
        noPushToken: 'Kein Push Token',
        usersWithTokens: '{{count}} Benutzer mit Push Token',
        totalRecipients: 'Gesamtempfänger',
        deliveredCount: 'Zugestellt',
        failedCount: 'Fehlgeschlagen',
        openedCount: 'Geöffnet',
        noTestHistory: 'Keine Testbenachrichtigungen gesendet',
        noCampaigns: 'Keine Kampagnen',
        noTemplates: 'Keine Vorlagen',
        noScheduled: 'Keine geplanten Nachrichten',
        selectUser: 'Benutzer auswählen',
        selectRole: 'Rolle auswählen',
        selectUsers: 'Benutzer auswählen',
        campaignSent: 'Kampagne erfolgreich gesendet',
        testSentSuccess: 'Testbenachrichtigung gesendet',
        templateCreated: 'Vorlage erstellt',
        templateUpdated: 'Vorlage aktualisiert',
        templateDeleted: 'Vorlage gelöscht',
        campaignCancelled: 'Kampagne abgebrochen',
        date: 'Datum',
        status: 'Status',
        actions: 'Aktionen',
        viewDetails: 'Details anzeigen',
        back: 'Zurück',
        close: 'Schließen',
        save: 'Speichern',
        create: 'Erstellen',
        smtpNotConfigured: 'SMTP nicht konfiguriert',
        selectTemplate: 'Vorlage auswählen',
        noActiveTokens: 'Keine aktiven Push Tokens',
    },
    apiKeys: {
        title: 'API-Schlüssel',
        create: 'API-Schlüssel erstellen',
        name: 'Schlüsselname',
        scopes: 'Berechtigungen',
        prefix: 'Schlüssel-Präfix',
        lastUsed: 'Zuletzt verwendet',
        expires: 'Ablaufdatum',
        never: 'Nie',
        neverUsed: 'Nie verwendet',
        active: 'Aktiv',
        revoked: 'Widerrufen',
        revoke: 'Widerrufen',
        copyWarning: 'Kopieren Sie diesen Schlüssel jetzt. Er wird nicht erneut angezeigt.',
        noKeys: 'Keine API-Schlüssel erstellt',
        created: 'API-Schlüssel erstellt',
        updated: 'API-Schlüssel aktualisiert',
        deleted: 'API-Schlüssel widerrufen',
        scopeReadOrders: 'Bestellungen lesen',
        scopeWriteOrders: 'Bestellungen schreiben',
        scopeReadProducts: 'Produkte lesen',
        scopeWriteProducts: 'Produkte schreiben',
        scopeReadCustomers: 'Kunden lesen',
        scopeReadAnalytics: 'Analysen lesen',
        scopeReadDashboard: 'Dashboard lesen',
        scopeReadNotifications: 'Benachrichtigungen lesen',
        scopeWriteNotifications: 'Benachrichtigungen schreiben',
        allScopes: 'Vollzugriff',
        site: 'Verknüpfter Shop',
        allSites: 'Alle Shops',
    },
    webhooks: {
        title: 'Webhooks',
        endpoints: 'Endpunkte',
        create: 'Endpunkt erstellen',
        url: 'Ziel-URL',
        events: 'Ereignisse',
        secret: 'Signaturschlüssel',
        description: 'Beschreibung',
        headers: 'Benutzerdefinierte Headers',
        active: 'Aktiv',
        disabled: 'Deaktiviert',
        failCount: 'Aufeinanderfolgende Fehler',
        disabledAt: 'Automatisch deaktiviert am',
        reactivate: 'Reaktivieren',
        testEvent: 'Testereignis senden',
        deliveries: 'Letzte Zustellungen',
        noEndpoints: 'Keine Webhook-Endpunkte konfiguriert',
        noDeliveries: 'Noch keine Zustellungen',
        created: 'Webhook-Endpunkt erstellt',
        updated: 'Webhook-Endpunkt aktualisiert',
        deleted: 'Webhook-Endpunkt gelöscht',
        reactivated: 'Webhook-Endpunkt reaktiviert',
        testSent: 'Testereignis gesendet',
        eventNewOrder: 'Neue Bestellung',
        eventStatusChanged: 'Bestellstatus geändert',
        eventLowStock: 'Niedriger Bestand',
        eventRefundCreated: 'Rückerstattung erstellt',
        eventBackorder: 'Nachbestellung',
        eventSubExpiring: 'Abonnement läuft ab',
        eventSubExpired: 'Abonnement abgelaufen',
        eventBridgeOffline: 'Bridge offline',
        attempt: 'Versuch',
        statusCode: 'Statuscode',
        duration: 'Dauer',
        site: 'Verknüpfter Shop',
        allSites: 'Alle Shops',
    },
};
//# sourceMappingURL=de.js.map